
export default {
  // 获取用户信息
  outsideUserMsg: process.env.VUE_APP_API_PREFIX + '/api-passport/user/info/base',
  //获取活动基本信息
  outsideGetHdDetail: process.env.VUE_APP_API_PREFIX + '/hd/activity-play/detail/',
  //获取用户报名情况
  outsideGetHdStatus: process.env.VUE_APP_API_PREFIX + '/hd/activity-play/',
  //活动报名接口设置微信号
  outsideApply: process.env.VUE_APP_API_PREFIX + '/hd/activity-play/apply',
  getURLScheme: process.env.VUE_APP_API_PREFIX + '/api-hd/mini_program/url-scheme',
  //集团用户中心登录-code
  outsideCheckCode: process.env.VUE_APP_API_PREFIX + '/api-passport/tal/udc/login/code',
  //获取订单id
  outsideGetOrderId: process.env.VUE_APP_API_PREFIX + '/api-shop/shopping/car',
  //获取收货地址
  outsideAdress: process.env.VUE_APP_API_PREFIX + '/api-passport/user/address/list',
  //今日头条交互
  outsideTouTiao: process.env.VUE_APP_API_PREFIX + '/hd/jump/toutiao',
  //sub_channel 解析
  outsideSubChannel: process.env.VUE_APP_API_PREFIX + '/hd/sub_channel/decode/',
  // 跳转小程序
  outsideSubChannel2: process.env.VUE_APP_API_PREFIX + '/api-hd/mini_program/url-scheme'
};
